export default "__VITE_ASSET__DgsDynQT__"